import React from "react"

/**
 * Vendored from the client's `ezbuild_lead_icon_pack`. The supplied files carry
 * a hardcoded `style="color:…"`; it is dropped here so each glyph takes the
 * colour of the pill it sits in.
 *
 * The pack ships three follow-up clocks (due today / upcoming / scheduled) whose
 * paths are identical — only that hardcoded colour separated them — so one clock
 * serves all three and the state is carried by colour alone. `DoNotContactIcon`
 * has no counterpart in the pack and is drawn here in the same style.
 */

type IconProps = React.SVGProps<SVGSVGElement>

const Glyph = ({ children, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth={4}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    {children}
  </svg>
)

export const HotIcon = (props: IconProps) => (
  <Glyph {...props}>
    <path d="M32 6c4 10-2 13-7 19-4 5-4 12 1 16 5 4 14 3 18-3 4-6 1-14-4-20-1 7-4 9-7 10 2-7 1-14-1-22z" />
  </Glyph>
)

export const ClockIcon = (props: IconProps) => (
  <Glyph {...props}>
    <circle cx="32" cy="32" r="22" />
    <path d="M32 20v13l8 5" />
  </Glyph>
)

export const NeedsInfoIcon = (props: IconProps) => (
  <Glyph {...props}>
    <circle cx="32" cy="32" r="22" />
    <path d="M32 28v14M32 20h.01" />
  </Glyph>
)

export const OnHoldIcon = (props: IconProps) => (
  <Glyph {...props}>
    <circle cx="32" cy="32" r="22" />
    <path d="M26 22v20M38 22v20" strokeWidth={5} />
  </Glyph>
)

export const RehashIcon = (props: IconProps) => (
  <Glyph {...props}>
    <path d="M47 25a18 18 0 0 0-31-5l-4 5M13 25h10M17 39a18 18 0 0 0 31-5l4-5M51 29H41" />
  </Glyph>
)

export const CalendarIcon = (props: IconProps) => (
  <Glyph {...props}>
    <rect x="14" y="16" width="36" height="34" rx="5" />
    <path d="M14 26h36M22 12v9M42 12v9" />
  </Glyph>
)

export const DoNotContactIcon = (props: IconProps) => (
  <Glyph {...props}>
    <circle cx="32" cy="32" r="22" />
    <path d="M17 17l30 30" />
  </Glyph>
)
